const initObserver = (
  target: Element | null,
  callback: IntersectionObserverCallback,
  options: IntersectionObserverInit,
) => {
  const observer = new IntersectionObserver(callback, options)

  if (target) {
    observer.observe(target)
  }

  return { observer }
}

export const useIntersectionObserver = (
  element: Element | string | null,
  options: IntersectionObserverInit = {
    root: null,
    rootMargin: '0px',
    threshold: 1.0,
  },
  callback?: IntersectionObserverCallback,
) => {
  // Если не передан элемент - выходим
  if (!element) return

  const isVisible = ref(false)

  /* Дефолтный callback для изменения флага видимости элемента */
  let callbackObserver: IntersectionObserverCallback = (
    entries: IntersectionObserverEntry[],
  ) => {
    const firstEntry = entries[0]
    isVisible.value = firstEntry.isIntersecting
  }

  /* Если передали callback */
  if (callback) {
    callbackObserver = callback
  }

  let observer = null

  switch (typeof element) {
    case 'string':
      /* Если переданный элемент - селектор */
      onMounted(() => {
        const target = document.querySelector(element)

        observer = initObserver(target, callbackObserver, options)
      })
      break
    case 'object':
      /* Если переданный элемент - HTML элемент */
      observer = initObserver(element, callbackObserver, options)
      break
    default:
      onMounted(() => {
        console.warn('нет')
      })
  }

  return {
    isVisible,
    observer,
  }
}
